import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { Button } from "react-bootstrap";

interface ImageCaptureProps {
  onImageSelect: (previewUrl: string, fileOrBlob: File | Blob) => void;
}

const ImageCapture: React.FC<ImageCaptureProps> = ({ onImageSelect }) => {
  const webcamRef = useRef<Webcam>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [captured, setCaptured] = useState(false);

  // Capture image from webcam
  const capture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      setPreview(imageSrc);
      setCaptured(true);
      onImageSelect(imageSrc, base64ToBlob(imageSrc));
    }
  };

  // Retake image
  const retake = () => {
    setPreview(null);
    setCaptured(false);
  };

  // Convert base64 to Blob
  const base64ToBlob = (base64: string) => {
    const byteString = atob(base64.split(",")[1]);
    const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  return (
    <div className="mb-3">
      {!captured ? (
        <>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/png"
            className="rounded shadow-sm mb-3"
            videoConstraints={{ facingMode: "user" }}
          />
          <Button variant="primary" onClick={capture}>Capture</Button>
        </>
      ) : (
        <div className="text-center">
          <img
            src={preview!}
            alt="Captured"
            style={{ maxHeight: "200px", borderRadius: "8px" }}
          />
          <div className="mt-2">
            <Button variant="secondary" onClick={retake}>
              Retake
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageCapture;
